<div class="approval-card-container">
    <div class="card">
        <div class="primary-text">
            Approve Onboarding
        </div>

        <div class="action-button">

            <!-- <button class="reject">
                Reject Onboarding
            </button> -->

            <button class="approve">
                Approve Onboarding
            </button>

        </div>
    </div>
</div>